module.exports = __webpack_public_path__ + "static/media/nSJu7wqfLl.a27a00c7.jpg";